import {
  ANALYTICS_EVENTS,
  ANALYTICS_PROPERTY_KEYS,
  COMPONENT_OUTCOMES,
  ERROR_SEVERITIES,
  ERROR_TYPES,
} from '../constants';
import { trackAnalyticsEvent } from '../core/analyticsClient';
import { hashAnalyticsErrorId } from '../utils/errorHash';

export type TrackErrorOccurredParams = {
  errorType: (typeof ERROR_TYPES)[keyof typeof ERROR_TYPES];
  errorSeverity?: (typeof ERROR_SEVERITIES)[keyof typeof ERROR_SEVERITIES];
  graphqlOperation?: string;
  errorCode?: string;
};

export const trackErrorOccurred = ({
  errorType,
  errorSeverity = ERROR_SEVERITIES.ERROR,
  graphqlOperation,
  errorCode,
}: TrackErrorOccurredParams): void => {
  trackAnalyticsEvent(ANALYTICS_EVENTS.ERROR_OCCURRED, {
    [ANALYTICS_PROPERTY_KEYS.ERROR_TYPE]: errorType,
    [ANALYTICS_PROPERTY_KEYS.ERROR_SEVERITY]: errorSeverity,
    [ANALYTICS_PROPERTY_KEYS.ERROR_ID_HASH]: hashAnalyticsErrorId([errorType, graphqlOperation, errorCode]),
    ...(graphqlOperation ? { [ANALYTICS_PROPERTY_KEYS.GRAPHQL_OPERATION]: graphqlOperation } : {}),
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.AUTO,
  });
};
